export const angularDefaultSource = `<!-- Array-based ngClass with ternary expressions -->
<div [ngClass]="[isPrimary ? 'primary' : '', isBold ? 'bold' : '', isLarge ? 'large' : '']">
  Primary Button
</div>

<!-- Another array-based ngClass example -->
<button [ngClass]="[isActive ? 'active' : '', isDisabled ? 'disabled' : '']">
  Click Me
</button>

<!-- More complex ngClass arrays with nested conditions -->
<span [ngClass]="[
  isImportant ? 'important' : '',
  isHighlighted ? 'highlight' : '',
  isError ? 'error' : isWarning ? 'warning' : ''
]">Warning Message</span>

<!-- Already using class binding with template strings -->
<div [class]="\`\${isPrimary ? 'primary' : ''} \${isBold ? 'bold' : ''}\`.trim()">
  Already Optimized
</div>
`;

export const angularDefaultCodemod = `import { type SgRoot } from "@ast-grep/napi";

async function transform(root: SgRoot): Promise<string | null> {
  const rootNode = root.root();

  // Find all ngClass array bindings
  const ngClassArrayNodes = rootNode.findAll({
    rule: {
      pattern: '[ngClass]="[$EXPRESSIONS]"',
      inside: {
        kind: "attribute"
      }
    }
  });

  const edits = ngClassArrayNodes.map(node => {
    // Get the expressions inside the array
    const arrayExpressionsText = node.getMatch("EXPRESSIONS").text();
    
    // Handle cases where this is not an array of ternaries
    if (!arrayExpressionsText.includes(' ? ')) {
      return null;
    }
    
    // Parse the expressions (this is the complex part)
    // We need to process each ternary expression in the array
    const ternaryExpressions = arrayExpressionsText
      .split(',')
      .map(expr => expr.trim())
      .filter(expr => expr.length > 0);
    
    // Transform each ternary expression into a template string part
    const templateParts = ternaryExpressions.map(ternary => {
      // Simple regex to extract parts of the ternary
      // This assumes a basic format of "condition ? 'trueValue' : ''"
      const ternaryMatch = ternary.match(/([^?]+) *\\? *([^:]+) *: *(.*)/);
      if (!ternaryMatch) return null;
      
      const conditionPart = ternaryMatch[1].trim();
      const truePart = ternaryMatch[2].trim();
      const falsePart = ternaryMatch[3].trim();
      
      // Create a template string segment
      return \`\\\${\${conditionPart} ? \${truePart} : \${falsePart}}\`;
    }).filter(Boolean);
    
    if (templateParts.length === 0) return null;
    
    // Construct the new class binding with template string
    const newClassBinding = \`[class]="\\\`\${templateParts.join(' ')}\\\`.trim()"\`;
    
    return node.replace(newClassBinding);
  }).filter(Boolean); // Remove null edits
  
  // Apply all changes
  const newSource = rootNode.commitEdits(edits);
  return newSource;
}

export default transform;
`;

export const angularDefaultConfig = `id: angular-find-ngclass-binding
language: angular
rule:
  kind: property_binding
  has:
    kind: binding_name
    regex: ^ngClass$
`.trim();
